import React, { PropsWithChildren } from 'react';

import cx from 'classnames';

import s from './index.module.css';

function PageWrapper({ children }: PropsWithChildren) {
  return (
    <div className={cx(s.page, 'pdfPage')}>
      <div className={s.innerPage}>{children}</div>
    </div>
  );
}

export default PageWrapper;
